export const ALL_USERS_GROUP_ID = 'allUsers';
